import React from 'react'
import * as Sentry from '@sentry/react'
import {useLocation} from 'react-router-dom'
import {useMount} from 'ahooks'
import {NormalHeader} from 'hiya-common/src/components/BasicHeader'
import {useEnv} from 'hiya-common/src/reducers/env'
import {useIsSaada} from 'hiya-common/src/utils/hooks/useIsSaada'
import hiyaErr from './images/404.png'
import saadaErr from './images/saada404.png'
import './index.scss'

const NotFound = (props: {isSentry?: boolean}) => {
  const isSentry = props.isSentry !== undefined ? props.isSentry : true

  const {deviceinfo} = useEnv()
  const location = useLocation()
  const isSaada = useIsSaada()

  useMount(() => {
    const isSend = deviceinfo.h_m && location.pathname !== '/'

    if (isSend && isSentry) {
      Sentry.captureEvent({
        message: '页面404异常',
        level: 'error',
      })
    }
  })

  const title = isSaada ? 'Saada' : 'Hiya'

  return (
    <>
      <NormalHeader title={title} right={<></>} />
      <div className="NotFound">
        <div
          className="NotFound__img"
          style={{backgroundImage: `url(${isSaada ? saadaErr : hiyaErr})`}}
        />
        <div className="NotFound__txt">Oops! Not found!</div>
      </div>
    </>
  )
}

export default NotFound
